import {Component, EventEmitter, inject, Input, OnInit, Output, signal} from '@angular/core';
import {CommonModule, DatePipe, NgOptimizedImage} from '@angular/common';
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {UserService} from '@services/user.service';
import {OdooService} from '@services/odoo.service';
import {ApiService} from '@services/api.service';

@Component({
  selector: 'app-request',
  imports: [
    DatePipe, CommonModule, ReactiveFormsModule, NgOptimizedImage
  ],
  templateUrl: './request.component.html',
  styleUrl: './request.component.css'
})
export class RequestComponent implements OnInit {

  private fb = inject(FormBuilder);

  @Input() item: any;
  @Output() goBackToMyRequests = new EventEmitter<void>();


  selectedFiles: File[] = [];
  base64Files: any[] = [];

  result: string = '';

  activeTab = signal('messages')
  submitted = signal(false);

  constructor(
    private http: HttpClient,
    private userService: UserService,
    private odooService: OdooService,
    private apiService: ApiService,
    ) {
  }

  messagesForm = new Map<number, FormGroup>();

  goBack() {
    this.goBackToMyRequests.emit()
  }

  sendIntegration(messageId: number) {
    if (this.getFormForMessage(messageId).valid) {

      const formData = {
        ...this.getFormForMessage(messageId).value,
        attachments: this.base64Files
      }

      const jsonPayload = JSON.stringify(formData, null, 2);

      this.apiService.integrateRequest(jsonPayload).subscribe({
        next: (response: any) => {
          this.submitted.set(true);
          this.result = response.result.message
          this.apiService.getRequest(this.item.id).subscribe(
            (item: any) => {
              console.log(item);
              this.item = item.data;
              this.submitted.set(false)
            });

        },
        error: (error) => {
          this.result = error.error.message
        },
        complete: () => {

        }
      });

    }
  }

  async readBase64File(file: File) {
    return await new Promise((resolve => {
      let reader = new FileReader();
      reader.onload = (e) => resolve(reader.result);
      reader.readAsDataURL(file);
    }));
  }


  onFileSelected(event: Event) {
    this.selectedFiles = [];
    this.base64Files = [];
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.selectedFiles = Array.from(input.files);

      this.selectedFiles.forEach(file => {

        this.readBase64File(file).then(value => {
          this.base64Files.push({
            filename: file.name,
            filetype: file.type,
            size: file.size,
            base64: (value as string).split(',')[1]
          })
        })
      })
    }

  }

  selectTab(tabName: string) {
    this.activeTab.set(tabName);
  }

  ngOnInit(): void {
    this.buildForms();
  }

  getFormForMessage(messageId: number): FormGroup {
    const form = this.messagesForm.get(messageId);
    if (!form) {
      console.error(`Form not found for message ${messageId}`);
    }
    return form || new FormGroup({});
  }

  fetchRequest() {
    this.apiService.getRequest(this.item.id).subscribe(
      (item: any) => {
        this.item = item.data;
        this.buildForms();
      });
  }

  buildForms() {
    this.messagesForm.clear();
      this.item.messages.forEach((message: any) => {
        this.messagesForm.set(message.id, this.fb.group({
          requestId: new FormControl(this.item.id, [Validators.required]),
          activityId: new FormControl(message.activityId, []),
          messageId: new FormControl(message.id, [Validators.required]),
          message: new FormControl('', [Validators.required]),
          mail: new FormControl(this.userService.getUser()?.username, [Validators.required, Validators.email]),
          attachments: new FormControl<any[]>([])
        }))
      })
  }

  getStateColor(state: string) {
    return {
      'in_progress': '#d9a31a',
      'to_do': '#194cc2',
      'accepted': '#19c243',
    }[state] ?? '#666666';
  }

  downloadDocument(id: number, type: string) {
    this.apiService.getDocument(id).subscribe((response: any) => {
        const fileBase64 = response.content;
        const fileName = response.fileName;
        const mimeType = type.toLowerCase() || "application/octet-stream";

        const byteCharacters = atob(fileBase64);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
          const slice = byteCharacters.slice(offset, offset + 512);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: mimeType });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);

    });
  }
}


